const statsData = [
    {
        year: 2023,
        debt: 7.74,
        gdpPercent: 19.6,
        interest: 174.50
    },
    {
        year: 2024,
        debt: 9.35,
        gdpPercent: 23.5,
        interest: 238.80
    },
    {
        year: 2025,
        debt: 9.76,
        gdpPercent: 23.3,
        interest: 209.50
    },
    {
        year: 2026,
        debt: 11.47,
        gdpPercent: 25.9,
        interest: 265.80
    },
    {
        year: 2027,
        debt: 13.55,
        gdpPercent: 29.2,
        interest: 324.80
    },
    {
        year: 2028,
        debt: 15.52,
        gdpPercent: 32.0,
        interest: 388.00
    },
    {
        year: 2029,
        debt: 17.49,
        gdpPercent: 34.5,
        interest: 456.30
    }
];
const HOUSEHOLDS_TOTAL = 651000;
const POPULATION_TOTAL = 1369995;
const debtByYear = {};
statsData.forEach((d)=>{
    debtByYear[d.year] = d.debt * 1000000000;
});
const TIMELINE_START_YEAR = 2024;
const TIMELINE_END_YEAR = 2030;
const PIXELS_PER_DAY = 1;
let targetDate = null;
let isProgrammaticScroll = false;
function getCurrentTime() {
    return targetDate || new Date();
}
function calculateCurrentDebt() {
    const now = getCurrentTime();
    const currentYear = now.getFullYear();
    if (currentYear >= 2030) {
        const finalDebt = debtByYear[2029];
        const householdDebtCurrent = finalDebt / HOUSEHOLDS_TOTAL;
        const debtPerPersonCurrent = finalDebt / POPULATION_TOTAL;
        return {
            currentDebt: finalDebt,
            debtGrowth: 0,
            currentYear: 2030,
            currentYearEndDebt: finalDebt,
            householdDebtCurrent,
            debtPerPersonCurrent,
            householdInterestAccrued: 0
        };
    }
    const startOfYear = new Date(currentYear, 0, 1);
    const startOfNextYear = new Date(currentYear + 1, 0, 1);
    const secondsInYear = (startOfNextYear - startOfYear) / 1000;
    const secondsElapsed = (now - startOfYear) / 1000;
    const safeYear = Math.max(2024, Math.min(currentYear, 2029));
    const currentYearEndDebt = debtByYear[safeYear] || debtByYear[2029];
    const previousYearEndDebt = debtByYear[safeYear - 1] || debtByYear[2024];
    const debtGrowth = (currentYearEndDebt - previousYearEndDebt) / secondsInYear;
    const currentDebt = previousYearEndDebt + debtGrowth * secondsElapsed;
    const householdDebtCurrent = currentDebt / HOUSEHOLDS_TOTAL;
    const debtPerPersonCurrent = currentDebt / POPULATION_TOTAL;
    const currentYearData = statsData.find((d)=>d.year === safeYear);
    const annualInterestTotal = currentYearData ? currentYearData.interest * 1000000 : 0;
    const annualInterestPerHousehold = annualInterestTotal / HOUSEHOLDS_TOTAL;
    const householdInterestAccrued = annualInterestPerHousehold * (secondsElapsed / secondsInYear);
    return {
        currentDebt,
        debtGrowth,
        currentYear: safeYear,
        currentYearEndDebt,
        householdDebtCurrent,
        debtPerPersonCurrent,
        householdInterestAccrued
    };
}
function formatNumber(num) {
    return Math.floor(num).toLocaleString('et-EE', {
        maximumFractionDigits: 0
    });
}
function formatCurrency(num) {
    return num.toLocaleString('et-EE', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    });
}
function formatCents(num) {
    const cents = Math.floor(num % 1 * 100);
    return ',' + cents.toString().padStart(2, '0');
}
function formatGrowthRate(num) {
    return num.toLocaleString('et-EE', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    });
}
const dateFormatter = new Intl.DateTimeFormat('et-EE', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric'
});
function updateCounter() {
    const { currentDebt, debtGrowth, currentYear, currentYearEndDebt, householdDebtCurrent, debtPerPersonCurrent } = calculateCurrentDebt();
    const counterElement = document.getElementById('debtCounter');
    const centsElement = document.getElementById('centsCounter');
    const yearElement = document.getElementById('currentYear');
    const growthElement = document.getElementById('growthRate');
    const yearEndDebtElement = document.getElementById('yearEndDebt');
    const householdDebtElement = document.getElementById('householdDebt');
    const debtPerPersonElement = document.getElementById('debtPerPerson');
    const dateDisplay = document.getElementById('timelineDateDisplay');
    const resetButton = document.getElementById('resetButton');
    const timelineHint = document.getElementById('timelineHint');
    if (counterElement) counterElement.textContent = formatNumber(currentDebt);
    if (centsElement) centsElement.textContent = formatCents(currentDebt);
    if (yearElement) yearElement.textContent = currentYear;
    if (yearEndDebtElement) yearEndDebtElement.textContent = formatNumber(currentYearEndDebt);
    if (growthElement) growthElement.textContent = formatGrowthRate(debtGrowth);
    if (householdDebtElement) householdDebtElement.textContent = formatNumber(householdDebtCurrent);
    if (debtPerPersonElement) debtPerPersonElement.textContent = formatNumber(debtPerPersonCurrent);
    const now = getCurrentTime();
    if (dateDisplay) dateDisplay.textContent = dateFormatter.format(now);
    if (resetButton) {
        if (targetDate) {
            resetButton.classList.remove('opacity-0', 'pointer-events-none');
            if (timelineHint) timelineHint.classList.add('opacity-0');
        } else {
            resetButton.classList.add('opacity-0', 'pointer-events-none');
            if (timelineHint) timelineHint.classList.remove('opacity-0');
        }
    }
}
function initTimeline() {
    const track = document.getElementById('timelineTrack');
    const container = document.getElementById('timelineContainer');
    if (!track || !container) return;
    const startDate = new Date(TIMELINE_START_YEAR, 0, 1);
    const endDate = new Date(TIMELINE_END_YEAR, 0, 1);
    let currentDate = new Date(startDate);
    track.innerHTML = '';
    while(currentDate < endDate){
        const year = currentDate.getFullYear();
        const month = currentDate.getMonth();
        let daysInQuarter = 0;
        for(let i = 0; i < 3; i++)daysInQuarter += new Date(year, month + i + 1, 0).getDate();
        const width = daysInQuarter * PIXELS_PER_DAY;
        const tick = document.createElement('div');
        tick.className = 'relative flex-shrink-0 h-full';
        tick.style.width = `${width}px`;
        const line = document.createElement('div');
        const isYearStart = month === 0;
        if (isYearStart) {
            line.className = `absolute bottom-0 left-0 w-0.5 bg-white h-full shadow-sm`;
            const startOfYear = new Date(year, 0, 1);
            const startOfNextYear = new Date(year + 1, 0, 1);
            const daysInYear = (startOfNextYear - startOfYear) / 86400000;
            const yearWidthPixels = daysInYear * PIXELS_PER_DAY;
            const label = document.createElement('div');
            label.className = 'absolute bottom-8 md:bottom-auto md:top-1/2 md:-translate-y-1/2 text-lg font-bold text-white select-none drop-shadow-md transform -translate-x-1/2';
            label.textContent = year;
            label.style.left = `${yearWidthPixels / 2}px`;
            tick.appendChild(label);
        } else {
            line.className = `absolute bottom-0 left-0 w-px bg-white/60 h-6`;
            tick.appendChild(line);
        }
        tick.appendChild(line);
        track.appendChild(tick);
        currentDate.setMonth(month + 3);
    }
    // Add 2030 line
    const endTick = document.createElement('div');
    endTick.className = 'relative flex-shrink-0 h-full';
    endTick.style.width = '20px'; // Minimal buffer
    const endLine = document.createElement('div');
    endLine.className = `absolute bottom-0 left-0 w-0.5 bg-white h-full shadow-sm`;
    const endLabel = document.createElement('div');
    endLabel.className = 'absolute bottom-8 md:bottom-auto md:top-1/2 md:-translate-y-1/2 text-lg font-bold text-white select-none drop-shadow-md';
    endLabel.textContent = TIMELINE_END_YEAR;
    endLabel.style.left = '8px';
    endTick.appendChild(endLine);
    endTick.appendChild(endLabel);
    track.appendChild(endTick);
    const updatePadding = ()=>{
        const halfScreen = container.clientWidth / 2;
        track.style.setProperty('--timeline-center-offset', `${halfScreen}px`);
        track.style.paddingLeft = 'var(--timeline-center-offset)';
        track.style.paddingRight = 'var(--timeline-center-offset)';
    };
    updatePadding();
    markTodayOnTimeline(track, startDate);
    let isDown = false;
    let startX;
    let scrollLeft;
    container.addEventListener('mousedown', (e)=>{
        isDown = true;
        container.style.cursor = 'grabbing';
        startX = e.pageX - container.offsetLeft;
        scrollLeft = container.scrollLeft;
    });
    container.addEventListener('mouseleave', ()=>{
        isDown = false;
        container.style.cursor = 'grab';
    });
    container.addEventListener('mouseup', ()=>{
        isDown = false;
        container.style.cursor = 'grab';
    });
    container.addEventListener('mousemove', (e)=>{
        if (!isDown) return;
        e.preventDefault();
        const x = e.pageX - container.offsetLeft;
        const walk = x - startX;
        container.scrollLeft = scrollLeft - walk;
    });
    container.addEventListener('scroll', ()=>{
        if (isProgrammaticScroll) {
            isProgrammaticScroll = false;
            return;
        }
        const scrollLeft = container.scrollLeft;
        const totalDaysOffset = scrollLeft / PIXELS_PER_DAY;
        const calculatedDate = new Date(startDate.getTime() + totalDaysOffset * 86400000);
        const clampedDate = new Date(Math.min(Math.max(calculatedDate.getTime(), startDate.getTime()), endDate.getTime()));
        targetDate = clampedDate;
        updateCounter();
    });
    window.addEventListener('resize', ()=>{
        updatePadding();
        scrollToDate(getCurrentTime());
    });
    setTimeout(()=>{
        scrollToDate(new Date());
        targetDate = null;
    }, 100);
}
function markTodayOnTimeline(track, startDate) {
    const today = new Date();
    const diffTime = today - startDate;
    const diffDays = diffTime / 86400000;
    const leftPos = diffDays * PIXELS_PER_DAY;
    const marker = document.createElement('div');
    marker.className = 'absolute bottom-0 w-0.5 h-6 bg-[#ff6600] z-10 opacity-80';
    marker.style.left = '0';
    marker.style.transform = `translateX(calc(var(--timeline-center-offset) + ${leftPos}px))`;
    marker.title = "T\xe4na";
    track.appendChild(marker);
}
function scrollToDate(date) {
    const container = document.getElementById('timelineContainer');
    if (!container) return;
    const startDate = new Date(TIMELINE_START_YEAR, 0, 1);
    const diffTime = date - startDate;
    const diffDays = diffTime / 86400000;
    const pixels = diffDays * PIXELS_PER_DAY;
    isProgrammaticScroll = true;
    container.scrollLeft = pixels;
}
document.getElementById('resetButton')?.addEventListener('click', ()=>{
    scrollToDate(new Date());
    targetDate = null;
    updateCounter();
});
const displayData = statsData.filter((d)=>d.year >= 2024);
function initCharts() {
    const debtChartEl = document.getElementById('debtChart');
    const gdpInterestChartEl = document.getElementById('gdpInterestChart');
    if (!debtChartEl || !gdpInterestChartEl || typeof Chart === 'undefined') return;
    Chart.defaults.font.family = "'Agenor Neue', sans-serif";
    Chart.defaults.color = '#64748b';
    const debtCtx = debtChartEl.getContext('2d');
    new Chart(debtCtx, {
        type: 'line',
        data: {
            labels: displayData.map((d)=>d.year),
            datasets: [
                {
                    label: "V\xf5lg (miljardit eurot)",
                    data: displayData.map((d)=>d.debt),
                    borderColor: '#ff6600',
                    backgroundColor: 'rgba(255, 102, 0, 0.1)',
                    borderWidth: 2,
                    pointBackgroundColor: '#ff6600',
                    pointBorderColor: '#fff',
                    pointRadius: 4,
                    fill: true,
                    tension: 0.3
                }
            ]
        },
        options: {
            responsive: true,
            maintainAspectRatio: false,
            plugins: {
                legend: {
                    display: false
                },
                tooltip: {
                    backgroundColor: '#fff',
                    titleColor: '#000',
                    bodyColor: '#000',
                    borderColor: '#e5e5e5',
                    borderWidth: 1,
                    padding: 10,
                    callbacks: {
                        label: (context)=>`${context.parsed.y} mld \u{20AC}`
                    }
                }
            },
            scales: {
                y: {
                    beginAtZero: false,
                    grid: {
                        borderDash: [
                            2,
                            4
                        ],
                        color: '#f1f5f9'
                    }
                },
                x: {
                    grid: {
                        display: false
                    }
                }
            }
        }
    });
    const gdpCtx = gdpInterestChartEl.getContext('2d');
    new Chart(gdpCtx, {
        type: 'bar',
        data: {
            labels: displayData.map((d)=>d.year),
            datasets: [
                {
                    type: 'line',
                    label: "V\xf5lg % SKP-st",
                    data: displayData.map((d)=>d.gdpPercent),
                    borderColor: '#ff6600',
                    backgroundColor: '#ff6600',
                    borderWidth: 2,
                    yAxisID: 'y',
                    tension: 0.1,
                    pointRadius: 4
                },
                {
                    type: 'bar',
                    label: "Intressikulu (mln \u20AC)",
                    data: displayData.map((d)=>d.interest),
                    backgroundColor: 'rgba(255, 102, 0, 0.15)',
                    hoverBackgroundColor: 'rgba(255, 102, 0, 0.25)',
                    yAxisID: 'y1',
                    borderRadius: 4
                }
            ]
        },
        options: {
            responsive: true,
            maintainAspectRatio: false,
            interaction: {
                mode: 'index',
                intersect: false
            },
            plugins: {
                legend: {
                    position: 'bottom',
                    labels: {
                        usePointStyle: true
                    }
                }
            },
            scales: {
                y: {
                    type: 'linear',
                    display: true,
                    position: 'right',
                    title: {
                        display: true,
                        text: '% SKP-st'
                    },
                    grid: {
                        display: false
                    }
                },
                y1: {
                    type: 'linear',
                    display: true,
                    position: 'left',
                    title: {
                        display: true,
                        text: "Intressikulu (mln \u20AC)"
                    },
                    grid: {
                        borderDash: [
                            2,
                            4
                        ],
                        color: '#f1f5f9'
                    }
                }
            }
        }
    });
}
function initTable() {
    const tableBody = document.getElementById('dataTableBody');
    if (!tableBody) return;
    displayData.forEach((row, index)=>{
        const tr = document.createElement('tr');
        tr.className = "hover:bg-stone-50 transition-colors";
        const prevYearData = statsData.find((d)=>d.year === row.year - 1);
        const prevDebt = prevYearData ? prevYearData.debt : index > 0 ? displayData[index - 1].debt : 0;
        const debtGrowth = (row.debt - prevDebt) * 1000000000;
        const debtGrowthPerHousehold = debtGrowth / HOUSEHOLDS_TOTAL;
        const interestPerHousehold = row.interest * 1000000 / HOUSEHOLDS_TOTAL;
        tr.innerHTML = `
            <th scope="row" class="px-6 py-4 font-medium text-slate-900 whitespace-nowrap">
                ${row.year}
            </th>
            <td class="px-6 py-4 text-right">
                ${row.debt.toFixed(2)}
            </td>
            <td class="px-6 py-4 text-right">
                ${row.gdpPercent}%
            </td>
            <td class="px-6 py-4 text-right">
                ${row.interest.toFixed(2)}
            </td>
            <td class="px-6 py-4 text-right font-medium text-[#ff6600]">
                ${formatNumber(debtGrowthPerHousehold)} \u{20AC}
            </td>
            <td class="px-6 py-4 text-right text-slate-600">
                ${formatNumber(interestPerHousehold)} \u{20AC}
            </td>
        `;
        tableBody.appendChild(tr);
    });
}
initTimeline();
updateCounter();
initCharts();
initTable();
setInterval(()=>{
    if (!targetDate) updateCounter();
}, 50);
setInterval(()=>{
    if (!targetDate) scrollToDate(new Date());
}, 60000);

//# sourceMappingURL=riigivolg.ec37c485.js.map
